import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'youtubeEmbed' })
export class YoutubeEmbedPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl | null {
    if (!url) {
      return null;
    }

    try {
      const urlObj = new URL(url);
      let videoId: string | null = null;

      if (url.includes('youtube.com/watch')) {
        videoId = urlObj.searchParams.get('v');
      } else if (url.includes('youtu.be/')) {
        videoId = urlObj.pathname.split('/')[1];
      } else if (url.includes('youtube.com/shorts/')) {
        videoId = urlObj.pathname.split('/shorts/')[1];
      } else if (url.includes('youtube.com/embed/')) {
        videoId = urlObj.pathname.split('/embed/')[1];
      }

      if (!videoId) {
        return null;
      }

      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    } catch {
      return null;
    }
  }
}
